import { useCallback, useState } from "react";
import { usePages } from "@lkf/hooks";

type ScrollView = "grid" | "detail";

export const useClusterScroll = (
  pageHeight: number,
  totalRows: number,
  limit: number
) => {
  const [gridScroll, setGridScroll] = useState(0);
  const [detailScroll, setDetailScroll] = useState(0);

  const {
    page: gridPage,
    onPageUp: onGridPageUp,
    onPageDown: onGridPageDown,
  } = usePages(totalRows, limit);

  const {
    page: detailPage,
    onPageUp: onDetailPageUp,
    onPageDown: onDetailPageDown,
    onPageReset: onDetailPageReset,
  } = usePages(totalRows, limit);

  const handleScrollDown = useCallback(
    (view: ScrollView) => {
      if (view === "grid") {
        setGridScroll((prevScroll) => prevScroll - pageHeight);
        return onGridPageUp();
      }
      setDetailScroll((prevScroll) => prevScroll - pageHeight);
      return onDetailPageUp();
    },
    [onGridPageUp, onDetailPageUp, pageHeight]
  );

  const handleScrollUp = useCallback(
    (view: ScrollView) => {
      if (view === "grid") {
        setGridScroll((prevScroll) => prevScroll + pageHeight);
        return onGridPageDown();
      }
      setDetailScroll((prevScroll) => prevScroll + pageHeight);
      return onDetailPageDown();
    },
    [onDetailPageDown, onGridPageDown, pageHeight]
  );

  const onResetDetailScroll = useCallback(() => {
    onDetailPageReset();
    setDetailScroll(0);
  }, [onDetailPageReset, setDetailScroll]);

  return {
    gridScroll,
    detailScroll,
    gridPage,
    detailPage,
    onResetDetailScroll,
    onPageUp: handleScrollUp,
    onPageDown: handleScrollDown,
  };
};
